<template>
<!--
    Account 매핑테이블 조회/수정
-->
<div class="content-wrap">
    <div class="search-wrap">
    <div class="row">
        <div class="col-md-2">
        <div class="mb-3">
            <ElLabel name="회사명">
            <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.cmp_nm"  @keyup.enter="searchAccount"/>
            </template>
            </ElLabel>
        </div>
        </div>
        <div class="col-md-2">
        <div class="mb-3">
            <ElLabel name="사업부명">
            <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.cmp_dvsn_nm" @keyup.enter="searchAccount"/>
            </template>
            </ElLabel>
        </div>
        </div>
        <div class="col-md-2">
        <div class="mb-3">
            <ElLabel name="사업자번호">
            <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.business_no"
                @update:modelValue="r=>bizNoFormat(state.searchParams.business_no)"     
                @keyup.enter="searchAccount"/>
            </template>
            </ElLabel>
        </div>
        </div>
        <!-- <div class="col-md-2">
        <div class="mb-3">
            <ElLabel name="영업대표">
            <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.ceo_nm" @keyup.enter="searchAccount"/>
            </template>
            </ElLabel>
        </div>
        </div> -->
        <div class="col-md-2" v-if="userStore.isAdmin">
        <div class="mb-3">
            <ElLabel name="AM">
            <template v-slot:end="slotProps">
                <ElInput :id="slotProps.id" v-model="state.searchParams.am_nm" @keyup.enter="searchAccount"/>
            </template>
            </ElLabel>
        </div>
        </div>
        <div class="col-md-2">
        <div class="mb-3">
            <label for="" class="form-label">회계년도</label>
            <DatePicker v-model="state.searchParams.acc_year" :format="'yyyy'" :year-picker="true" @return="r=>state.searchParams.acc_year = r" :selectDate="state.searchParams.acc_year"/>
        </div>
        </div>
        <div class="col-md-2">
        <div class="mb-3" v-if="userStore.isAdmin">
            
            <ElLabel name="매핑여부">
            <template #end="{id}">
                <div class="form-check">
                <ElLabel name="매핑">
                    <template #start="{id}">
                    <ElCheckbox
                        v-model="state.searchParams.check_am"
                    />
                    </template>
                </ElLabel>
                </div>
            </template>
            </ElLabel>

        </div>
        </div>
        
    </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
    <ElButton type="search" @buttonClick="searchAccount()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between">
    <div></div>
    <div class="table-btn-group">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
    </div>
    </div>
    <div class="table-list table-cf">
    <!--grid 영역-->
    <DataTable :value="state.gridRowData" paginator :rows="10" :rowsPerPageOptions="[10, 20, 50, 100, 200]"
        scrollable scrollHeight="465px"
        removableSort
        :pt="{
          wrapper : {style:'height : 465px'},
        }"
    >
        <template #empty>
        <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <!-- 체크박스 -->
        <Column>
            <template #header>
                <ElCheckbox v-model="allCheck"/>
            </template>
            <template #body="{ data }">
                <ElCheckbox 
                v-model="state.selectRows" 
                :value="data.cp_seq"
                />
            </template>
        </Column>
        <Column v-for="company of state.gridColumn" :field="company.field" :header="company.header"
        :style="company.style" :sortable="company.sortable">
        <!-- todo 필수값체크 -->
        <template #header="{ data, field }">
            <div v-if="field == 'am_nm'">
            <span>{{ data[field] }}<sup class="text-danger">*</sup></span>
            </div>
            <div v-else-if="field == 'class_nm1'">
            <span>{{ data[field] }}<sup class="text-danger">*</sup></span>
            </div>
            <div v-else-if="field == 'class_nm2'">
            <span>{{ data[field] }}<sup class="text-danger">*</sup></span>
            </div>
        </template>
        <template #body="{ data, field }">

            <div 
              v-if="field === 'cmp_dvsn_nm'" 
              v-bind:title="data.cmp_dvsn_nm" 
              style="width: 150px;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.cmp_dvsn_nm }}
            </div>
            <div 
              v-else-if="field === 'cmp_nm'" 
              v-bind:title="data.cmp_nm" 
              style="width:200px;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.cmp_nm }}
            </div>
            <div 
              v-else-if="field === 'note'" 
              v-bind:title="data.note" 
              style="width:150px;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.note }}
            </div>
            <!--그 외 cell-->
            <span v-else>{{ data[field] }}</span>
        </template>
        </Column>
    </DataTable>
    </div>

    <div class="text-end py-3">
    <!-- <ElButton type="primary" @buttonClick="openExcelUpload()">일괄등록</ElButton> -->
    <ElButton type="primary" @buttonClick="goBack()">이전</ElButton>
    </div>
</div>

<excelUtil ref="excelUtilRef" v-show="false" />
<ExcelManage v-show="false" ref="excelManage" :data-format="false"/>

</template>

<script setup>
import { reactive, onBeforeMount, onMounted ,ref, computed } from 'vue';
//component
import excelUtil from '@/components/common/MCO_EX_001.vue';
import ExcelManage from "@/components/common/MCO_EX_001.vue";
import vueRouterCmn from '@/js/vueRouterCmn';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { classList,accountCompList} from '@/api/comp';
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue'
import { useUserStore } from '@/store/user'

const userStore = useUserStore()

const excelUtilRef = ref()
// const excelUploadModalRef = ref()
const excelManage = ref();
onBeforeMount(async() => {
    const res = await classList()
    state.classList = [...res.rtn]
    
    let date = new Date()
    let year = date.getFullYear()
    year = year - 5

    for (let i = year; i < year + 11; i++) {
        state.fiscalYear.option.push({ name: i, value: i })
    }
    await searchAccount()

})

const allCheck = computed({
    get() {
        return state.gridRowData.length === state.selectRows.length;
    },
    set(newValue) {
        state.selectRows = newValue ? state.gridRowData.map((item) => { return item.cp_seq }) : [];
    }
})

//사업자번호 형식 체크
const bizNoFormat = (no) => {
    state.searchParams.business_no = common.bizNoFormat(no);
};


const state = reactive({
    selectRows: [],
    cmpClsSelectRow: [],
    amSrSelectRow: [],
    gridColumn: [],
    gridRowData: [],
    maxDepth: 2,
    searchParams: {
        cmp_nm: '',
        am_nm: '',
        cmp_dvsn_nm: '',
        business_no: '',
        ceo_nm: '',
        check_am: true,
        acc_year: common.getThisYear(),
        page_count: 1,
        unit_count: 1000000
    },
    modalSearchParams: {
        enable_yn: 'Y',
        employee_id: '',
        user_id: '',
        user_nm: ''
    },
    fiscalYear: {
        selected: '',
        option: []
    },
    maxRv: '',
    clickRow: {
        rowIndex: '',
        key: ''
    },
    tmpList: []
})



const searchAccount = async () => {
state.selectRows = []
state.searchParams.fiscalYear = state.fiscalYear.selected
let param = { ...state.searchParams }
param.check_am = param.check_am ? 'Y' : ''
state.gridColumn = [
    { header: "회계연도", field: "acc_year", style: { minWidth: '80px' }},
    { header: "회사관리번호", field: "cmp_info_seq", style: { minWidth: '150px' } },
    { header: "회사분류1", field: "class_nm1", style: { minWidth: '80px' } },
    { header: "회사분류2", field: "class_nm2", style: { minWidth: '80px' } },
    { header: "회사명", field: "cmp_nm", style: { minWidth: '60px' }},
    { header: "사업부", field: "cmp_dvsn_nm", style: { minWidth: '60px' }},
    { header: "사업자등록번호", field: "business_no", style: { minWidth: '150px' } },
    { header: "AM", field: "am_nm", style: { minWidth: '150px' } },
    { header: "메모", field: "note"},
    { header: "적용일자", field: "fmt_app_dt", style: { minWidth: '150px' } },
    { header: "등록일자", field: "fmt_reg_dt", style: { minWidth: '150px' } },
    { header: "수정일자", field: "fmt_upd_dt", style: { minWidth: '150px' } },
]
state.maxDepth = 2
try {
    setIsLoading(true)
    const res = await accountCompList(param)
    state.gridRowData = [...res.rtn].map((item, index) => {
    item.index = index + 1
    //매핑이된 회사분류 아이디값을 이름이랑 매칭 및 3단계 이상일시 그리드 컬럼 추가
    if (item.cl_class_id && item.cl_class_id != '' && item.cl_class_id != undefined) {
        let codeFam = common.findUperCode(item.cl_class_id, state.classList)
        if(codeFam){
            let length = Object.keys(codeFam).length

            if (length > state.maxDepth) {
                for (var i = (state.maxDepth + 1); i <= length; i++) {
                let col = { header: `회사분류${i}`, field: `class_nm${i}`, style: { minWidth: '100px' } }
                // state.listGridOption.colDefs.push(col)
                state.gridColumn.splice(i + 1, 0, col);
                state.maxDepth = i
                }
            }
            codeFam.forEach((code,index)=>{
                item[`class_nm${index+1}`] = code.class_nm
            })
        }
        
    }

    return item
    })
} catch (err) {
    console.error('/comp/accountCompList ERROR!! => ' + err)
    alert('api 에러 발생!!')
} finally {
    setIsLoading(false)
}
}

// const openExcelUpload = () => {
//   excelUploadModalRef.value.openModal()
// }

const goBack = () => {
vueRouterCmn.goBack()
}


//엑셀 다운로드
const excelDown = () => {
let fileNm = "Account 매핑테이블 리스트";
let header = state.gridColumn;
let dataList = state.gridRowData;

if (state.selectRows.length > 0) {
    dataList = state.gridRowData.filter((item) => {
    for (let i of state.selectRows) {
        if (i == item.cp_seq) {
        return item
        }
    }
    })

} 
excelManage.value.excelDownload(fileNm, header, dataList);


}
</script>